import { render } from "./Loading.vue?vue&type=template&id=65c07498&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=65c07498&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65c07498"

export default script